/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// useStrict
/* global ga */


expocadfx.setupGA = function( accountNumber) {
	var load = expocadfx.loadScript;
	
	window[ 'GoogleAnalyticsObject'] = 'ga';
	window['ga'] = window['ga'] || function(){
		( window['ga'].q = window['ga'].q || []).push( arguments);
	};
	window['ga'].l = 1 * new Date();
	load( "https://www.google-analytics.com/analytics.js", cbGoogleAccount, false);
	
	function cbGoogleAccount() {
		ga('create', accountNumber, 'auto');
		ga('send', 'pageview');
	}
};